// extracted by mini-css-extract-plugin
export default {"cta":"fJ-z","disabled":"gJ-z"};